import { useContext } from "react";

import { UserContext } from "../../../context/UserContext";
import { CustomerContext } from "../contexts/CustomerContext";
import { notify } from "../../../utils/notify";
import { postPromocode } from "../../../repositories/v1/promocode";
import { postLog } from "../../../repositories/v1/log";
import Swal from "sweetalert2";

export default function usePromocodeController() {
  const { user } = useContext(UserContext);
  const {
    customerExists,
    cnpj,
    consultantCompany,
    consultantUser,
    franchisedCompany,
    franchisedUser,
    accountantCompany,
    accountantUser,
    entityCompany,
    entityUser,
    loadings,
    setLoadings,
    setErrors,
  } = useContext(CustomerContext);

  /**
   * Parâmetro opcional:
   * Por conta da assincronicidade do setState, o state franchisedCompany setado pelo
   * componente de produtos caso o cliente não tenha franquia não estava chegando pronto
   * para função de save.
   */
  const handleSavePromocode = async ({ defaultFranchiseData }) => {
    try {
      if (Object.keys(loadings).find((key) => loadings[key])) {
        return notify("Aguarde todos os campos serem carregados.");
      }

      setLoadings((current) => ({ ...current, screen: true }));

      if (!customerExists || !cnpj) {
        return notify(
          "Antes de cadastrar o promocode salve os dados do cliente."
        );
      }

      const franchisedCompanyData = defaultFranchiseData || franchisedCompany;

      if (!franchisedCompanyData?.CNPJ) {
        setErrors((current) => ({
          ...current,
          franchiseField: true,
        }));

        return notify("Preencha franquia para salvar promocode.");
      }

      const body = {
        ClienteCNPJ: cnpj.replace(/[^0-9]+/g, ""),
        IdPromotorFranquia: franchisedCompanyData?.CNPJ || null,
        IdUsuarioFranquia: franchisedUser?.Id || null,
        DataFranquia: franchisedCompanyData?.CNPJ ? new Date() : null,

        IdPromotorEntidade: entityCompany?.CNPJ || null,
        IdUsuarioEntidade: entityUser?.Id || null,
        DataEntidade: entityCompany?.CNPJ ? new Date() : null,

        IdPromotorConsultor: consultantCompany?.CNPJ || null,
        IdUsuarioConsultor: consultantUser?.Id || null,
        DataConsultor: consultantCompany?.CNPJ ? new Date() : null,

        IdPromotorContador: accountantCompany?.CNPJ || null,
        IdUsuarioContador: accountantUser?.Id || null,
        DataContador: accountantCompany?.CNPJ ? new Date() : null,
      };

      const { data: respPromocode } = await postPromocode({ body });

      if (respPromocode?.success) {
        postLog({
          EmailUsuario: user?.Email,
          Descricao: `edição de promocode cliente(${cnpj.replace(
            /[^0-9]+/g,
            ""
          )})`,
          Origem: "plug",
          Tabela: "promocodes",
          Dados: JSON.stringify(body),
        });

        setErrors((current) => ({
          ...current,
          franchiseField: false,
        }));

        notify("Promocode salvo com sucesso.", true, "info");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadings((current) => ({ ...current, screen: false }));
    }
  };

  const questionDefaultFranchise = async () => {
    return Swal.fire({
      text: "Nenhuma franquia vinculada ao cliente como promocode. Deseja prosseguir com franquia padrão?",
      icon: "question",
      showConfirmButton: true,
      confirmButtonColor: "#0F52BA",
      confirmButtonText: "Sim, prosseguir",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      return result.isConfirmed;
    });
  };

  return {
    handleSavePromocode,
    questionDefaultFranchise,
  };
}
